/*LIBRARY*/
import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

/*COMPONENT*/
import GRID_STEP_1 from "./GRID_STEP_1";
import GRID_STEP_2 from "./GRID_STEP_2";
import GRID_STEP_3 from "./GRID_STEP_3";

/*HOOKS*/

/*REDUX*/
import {
  set_value_toolbox,
  status_toolbox,
} from "../../App/actions/toolboxActions";
import { set_value_layer } from "../../App/actions/layerActions";
import { status_action } from "../../App/actions/mapActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import { ArrowBackIos } from "@material-ui/icons";
import { parseRichText } from "../../App/validation/text_helper";
import useLanguage from "../common_hooks/useLanguage";

/*CONST*/

function TOOLBOX_GRID() {

  // hooks
  const dispatch = useDispatch();
  const { dict, language } = useLanguage();

  //local storage

  //local state
  const [step, set_step] = useState(0);

  //global props
  const { geo_layer_list } = useSelector(state => state.layer);
  const { modal_cancel_confirmation } = useSelector(state => state.toolbox);


  useEffect(() => {
    let layer_list_point_obj = {};
    let layer_list_polygon_obj = {}
    geo_layer_list.forEach(item => {
      if (item?.geo_layer?.type === "Point") layer_list_point_obj[item?.geo_layer?._id] = item?.geo_layer?.name;
      else if (item?.geo_layer?.type === "Polygon") layer_list_polygon_obj[item?.geo_layer?._id] = item?.geo_layer?.name;
    })
    dispatch(set_value_toolbox({
      key: "layer_list_point_obj",
      value: layer_list_point_obj,
    }));
    dispatch(set_value_toolbox({
      key: "layer_list_polygon_obj",
      value: layer_list_polygon_obj,
    }));
  }, [geo_layer_list, dispatch])

  const on_back = (value) => {
    let new_value = !modal_cancel_confirmation?.is_open;
    if (value === false || value === true) {
      new_value = value;
    }

    dispatch(
      set_value_toolbox({
        key: "modal_cancel_confirmation",
        value: {
          is_open: new_value,
          is_back_active: true,
          tab_value: "",
        },
      }),
    );

  }

  //content
  let step_content = <GRID_STEP_1 set_step={set_step} />;
  if (step === 1) step_content = <>
    <GRID_STEP_2 />
    <hr style={{ height: "1px", backgroundColor: "#BABABA", opacity: 0.2, marginTop: "10px" }} />
    <GRID_STEP_3 />
  </>
  // else if (step === 2) step_content = 

  return (
    <>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "30px 20px 25px 20px",
        }}
      >
        <button
          onClick={() => on_back()}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontWeight: 700,
            width: "fit-content",
            padding: "2px 10px",
            borderRadius: "2px",
          }}
        >
          <ArrowBackIos style={{ fontSize: "12px" }} />
          {dict["Back to Menu"][language]}
        </button>
      </section>

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "0 27px"
        }}
      >
        <div>
          <span style={{ fontSize: "18px", fontWeight: "700" }}>{dict["Select Layer"][language]}</span>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            {dict["This defines the point and polygon layers that will be used in the grid count analysis."][language]}
          </p>
        </div>


        <div
          style={{
            border: "1px solid #D3B572",
            backgroundColor: "#FFFAEC",
            padding: "8px 16px",
            borderRadius: "20px",
            fontSize: "12px",
            marginBottom: "20px",
            color: "#6C5D3A"
          }}
        >
          {parseRichText(dict["Select a {b}Point & Polygon Layer{/b} before continuing."][language])}
        </div>
      </section>

      <hr style={{ height: "5px", backgroundColor: "#BABABA", opacity: 0.1 }} />

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          margin: "0 27px 30px 27px"
        }}
      >
        <span style={{ fontSize: "14px" }}        >
          <p style={{ fontWeight: 600, display: "inline-block" }}>{`Step ${step + 1}/${2}`}</p>
          {` - `}
          <p style={{ fontWeight: 500, display: "inline-block" }}>
            {language === "ina" && `${dict["Setting"][language]} `}
            {`Grid${language === "eng" ? "s" : ""}`}
            {language === "eng" && ` ${dict["Setting"][language]}`}
          </p>
        </span>
        <div style={{ display: "flex", height: "20px" }}>
          <button
            onClick={() => set_step(0)}
            style={{ backgroundColor: "black", border: "1px solid black", height: "15px", width: "50%", borderRadius: "20px" }}
          />
          <button
            onClick={() => set_step(1)}
            style={{ backgroundColor: step === 1 ? "black" : "white", border: "1px solid black", height: "15px", width: "50%", borderRadius: "20px" }}
          />
        </div>
      </section>

      {step_content}
      {/*<GRID_STEP_1 />
      <hr style={{ height: "1px", backgroundColor: "#BABABA", opacity: 0.2, marginTop: "10px" }} />
      <GRID_STEP_2 />
      <hr style={{ height: "1px", backgroundColor: "#BABABA", opacity: 0.2, marginTop: "10px" }} />
      <GRID_STEP_3 /> */}
    </>
  );

}

const mapStateToProps = (state) => ({
  toolbox: state.toolbox,
  map: state.map,
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  set_value_toolbox,
  set_value_layer,
  status_action,
  status_toolbox,
})(TOOLBOX_GRID);
